/* tslint:disable */
/* eslint-disable */

/**
 * 1 = EnAttentePremiereVisite
 * 2 = EnAttenteImpression
 * 3 = Imprime
 */
export enum StatutFormulaireValues {
  EnAttentePremiereVisite = 1,
  EnAttenteImpression = 2,
  Imprime = 3
}
